<script setup lang="ts">
import { computed, watch } from "vue";
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'



const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()

//
// import { useUserStoreWithOut } from "@/store/modules/user";
// import { getUserDetailsInfoApi } from "@/api/user/user";
// const userStore = useUserStoreWithOut();
// watch(() => userStore.userInfo, async (newUserInfo) => {
//   if (newUserInfo && newUserInfo?.cc_token) {
//     await getUserDetailsInfoApi();
//   }
// }, { deep: true });

</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
